<template>
  <div class="container">
    <ul class="nav nav-pills nav-stacked">
      <li class="active">
        <router-link to="/help/basic">基础知识</router-link>
      </li>
      <li>
        <a>登录注册</a>
      </li>
      <li>
        <a>信息认证</a>
      </li>
      <li>
        <a>发布货源/求购</a>
      </li>
      <li>
        <a>订单交易</a>
      </li>
      <li>
        <a>售后服务</a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'homeHelpNavi'
  }
</script>

<style scoped>
  .container {
    width: auto;
  }
  li {
    white-space: nowrap;
    text-align: center;
    padding: 0;
    margin: 0;
  }
  .nav-stacked>li+li {
    margin: 0;
    border-width: 0.5px;
    border-style: solid;
    border-color: rgb(121, 121, 121);
  }

  .nav-pills>li>a {
    border-radius: 0;
  }

  .nav-pills > li > a:focus,
  .nav-pills > li > a:hover {
    background-color: rgb(69, 180, 88);
    color: white;
    font-weight: 200;
  }


  .nav-pills > li.active > a,
  .nav-pills > li.active > a:focus,
  .nav-pills > li.active > a:hover {
    background-color: rgb(69, 180, 88);
    color: white;
    font-weight: 200;
  }
  a {
    text-decoration: none;
    color: #333333;
    font-family: STHeitiSC-Light, "Heiti SC Light", "Heiti SC";
    font-weight: 200;
    font-style: normal;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// HomeHelpNavi.vue?5b2ba56c